import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import postReducer from './postSlice';
import chatReducer from './chatSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    post: postReducer,
    chat: chatReducer,
  },
});
